<template>
  <v-dialog v-model="value" max-width="400">
    <v-card>
      <v-card-title>
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn tile elevation="0" @click="close">
          {{ $dictionary.get('close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Mixin',
  computed: {
    dark() { return this.$store.state.theme.dialogDark; },
    color() { return this.$store.state.theme.dialogColor; },
    value: {
      get() { return true; },
      set() { this.close(); }
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>
